import {siteOptions} from '../../site/siteSettings'

export const labKindHelper = (props) => {
    let labKind = siteOptions.demoSite ? "demo" : "chemistry"
    let params = props.location.search?.substr(1).split("&") || []

    params.map((p) => {
        let pair = p.split('=')
        if (pair[0] === 'l') { labKind = pair[1] }
    })

    return labKind
}

export default {
    chemistry: {
        backgroundImage: "background-chem.png",
        explosionVideo: "./labexplosion-chem.mp4"
    },
    biology: {
        backgroundImage: "background-bio.png",
        explosionVideo: "./labexplosion-bio.mp4"
    },
    physics: {
        backgroundImage: "background-phys.png",
        explosionVideo: "./labexplosion-phys.mp4"
    },
    demo: {
        backgroundImage: "background-phys.png",
        explosionVideo: "./labexplosion-phys.mp4"
    }
}

